"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styled = require("@datepicker-react/styled");
var _automationHooks = require("@airportlabs/automation-hooks");
var DateParts = _interopRequireWildcard(require("./DateParts"));
var _ButtonsContainer = _interopRequireDefault(require("../Containers/ButtonsContainer"));
var _DatePickerReactStyled = _interopRequireDefault(require("./DatePickerReactStyled"));
var _Hr = _interopRequireDefault(require("../Typography/Hr"));
var _PrimaryButton = _interopRequireDefault(require("../Buttons/PrimaryButton"));
var _SecondaryButton = _interopRequireDefault(require("../Buttons/SecondaryButton"));
var _StartEndDates = _interopRequireDefault(require("./StartEndDates"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
var _useTimezoneDate2 = _interopRequireDefault(require("../_hooks/useTimezoneDate"));
var _excluded = ["onChange", "initialValue", "format", "align", "automationHook"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/** TODO: update API for this component to receive value. */

var propTypes = {
  /** Used to set the saved range value when a range is selected. Will receive as argument an object with startDate and endDate  */
  onChange: _propTypes["default"].func.isRequired,
  /** The initial value for the DatePicker. Should contain Date objects for start and end dates */
  initialValue: _propTypes["default"].shape({
    startDate: _propTypes["default"].object,
    endDate: _propTypes["default"].object
  }),
  /** React Tiny Popover API https://github.com/alexkatz/react-tiny-popover#popover
   * Alignment of the Popover relative to the input
   */
  align: _propTypes["default"].oneOf(["start", "center", "end"]),
  /** A Luxon DateTime Format String, used to represent the date in Start and End date inputs. By default is dd.MM.yyyy */
  format: _propTypes["default"].string,
  /** Hook used for automation testing. For Text the suffix 'text' is added, for SecondaryButton's the suffixes 'cancel' and 'done' are added.*/
  automationHook: _propTypes["default"].string
};
var getRangeBoundary = function getRangeBoundary(date, getFromJSDate) {
  var boundary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "start";
  var dateObject = getFromJSDate(date);
  return (boundary === "start" ? dateObject.startOf("day") : dateObject.endOf("day")).toJSDate();
};
var getInitialValue = function getInitialValue(_ref, getFromJSDate) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate;
  return {
    startDate: startDate ? getRangeBoundary(startDate, getFromJSDate) : null,
    endDate: endDate ? getRangeBoundary(endDate, getFromJSDate, "end") : null,
    focusedInput: _styled.START_DATE
  };
};
var StyledDatePicker = function StyledDatePicker(_ref2) {
  var onChange = _ref2.onChange,
    initialValue = _ref2.initialValue,
    _ref2$format = _ref2.format,
    format = _ref2$format === void 0 ? "dd.MM.yyyy" : _ref2$format,
    align = _ref2.align,
    automationHook = _ref2.automationHook,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useTimezoneDate = (0, _useTimezoneDate2["default"])(),
    getFromJSDate = _useTimezoneDate.getFromJSDate;

  // TODO: if we wanna make this a controlled field (to use with formik),
  // replace initialValue with value and add a useEffect to update internal
  // state when value is updated

  var _useState3 = (0, _react.useState)(getInitialValue(initialValue || {}, getFromJSDate)),
    _useState4 = _slicedToArray(_useState3, 2),
    datePickerState = _useState4[0],
    setDatePickerState = _useState4[1];
  var dateTimeMeta = (0, _react.useMemo)(function () {
    return {
      startDate: datePickerState.startDate ? getFromJSDate(datePickerState.startDate) : null,
      endDate: datePickerState.endDate ? getFromJSDate(datePickerState.endDate) : null
    };
  }, [datePickerState, getFromJSDate]);
  var handleDatesChange = function handleDatesChange(_ref3) {
    var startDate = _ref3.startDate,
      endDate = _ref3.endDate,
      focusedInput = _ref3.focusedInput;
    if (!focusedInput) {
      setDatePickerState({
        startDate: startDate,
        endDate: getRangeBoundary(endDate, getFromJSDate, "end"),
        focusedInput: _styled.START_DATE
      });
    } else {
      setDatePickerState({
        startDate: startDate,
        endDate: endDate,
        focusedInput: focusedInput
      });
    }
  };
  var doneClickHandle = function doneClickHandle(closePopover) {
    if (!datePickerState.endDate) {
      setError(true);
    } else {
      closePopover();
      setError(false);
    }
  };
  var cancelClickHandle = function cancelClickHandle(closePopover) {
    closePopover();
    // reset the internal state to the initialValue
    setDatePickerState(getInitialValue(initialValue || {}, getFromJSDate));
  };
  return /*#__PURE__*/_react["default"].createElement(DateParts.Popover, {
    onClose: function onClose() {
      // update the external state only when user is done selecting the dates
      onChange(datePickerState);
    },
    align: align,
    onClickOutside: function onClickOutside() {} // prevent clicking outside
    ,
    renderTrigger: function renderTrigger(_ref4) {
      var togglePopover = _ref4.togglePopover,
        isOpen = _ref4.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_StartEndDates["default"], {
        dates: {
          startDate: dateTimeMeta.startDate,
          endDate: dateTimeMeta.endDate
        },
        togglePopover: togglePopover,
        isOpen: isOpen,
        focusedInput: datePickerState.focusedInput,
        format: format,
        automationHook: automationHook
      });
    }
  }, function (_ref5) {
    var openPopover = _ref5.openPopover,
      closePopover = _ref5.closePopover;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DatePickerReactStyled["default"], _extends({
      onDatesChange: handleDatesChange,
      startDate: datePickerState.startDate // Date or null
      ,
      endDate: datePickerState.endDate // Date or null
      ,
      focusedInput: datePickerState.focusedInput // START_DATE, END_DATE or null
      ,
      automationHook: automationHook,
      currentDate: datePickerState,
      setCurrentDate: setDatePickerState
    }, rest)), /*#__PURE__*/_react["default"].createElement(_Hr["default"], {
      mT: "base",
      mB: "m"
    }), error && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      color: "error",
      mB: "m",
      automationHook: (0, _automationHooks.getHook)(automationHook, "text")
    }, "Please select the End Date."), /*#__PURE__*/_react["default"].createElement(_ButtonsContainer["default"], {
      buttonsW: "70px"
    }, /*#__PURE__*/_react["default"].createElement(_SecondaryButton["default"], {
      onClick: function onClick() {
        return cancelClickHandle(closePopover);
      },
      automationHook: (0, _automationHooks.getHook)(automationHook, "cancel")
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_PrimaryButton["default"], {
      onClick: function onClick() {
        return doneClickHandle(closePopover);
      },
      automationHook: (0, _automationHooks.getHook)(automationHook, "done")
    }, "Done")));
  });
};
StyledDatePicker.propTypes = propTypes;
var _default = exports["default"] = StyledDatePicker;